import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";
import CTASection from "../components/sections/CTASection";
import { getAccidentTypes } from "../lib/api";

export default function AccidentTypes() {
  const [items, setItems] = useState([]);
  useEffect(() => { getAccidentTypes().then(setItems).catch(() => {}); }, []);

  return (
    <>
      <SEO
        title="All Accident Types | Ohio Accident Aid"
        description="From car crashes to truck accidents, motorcycle wrecks to slip and falls — we help Ohio victims of every accident type."
        extraSchemas={[{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://ohioaccidentaid.com/" },
            { "@type": "ListItem", "position": 2, "name": "Accident Types", "item": "https://ohioaccidentaid.com/accident-types" },
          ],
        }]}
      />
      <section className="pt-12 md:pt-20 pb-12 px-6 bg-bone">
        <div className="max-w-7xl mx-auto">
          <div className="overline mb-3">All Accident Types</div>
          <h1 className="text-4xl md:text-6xl font-display font-bold text-forest tracking-tight mb-5 text-balance max-w-3xl">
            Every accident is different. Every claim deserves attention.
          </h1>
          <p className="text-lg text-charcoal-soft max-w-2xl">
            Browse our specialty pages — each one with Ohio-specific information and what to do next.
          </p>
        </div>
      </section>

      <section className="px-6 pb-20">
        <div className="max-w-7xl mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((it) => {
            const I = Icons[it.icon] || Icons.AlertTriangle;
            return (
              <Link
                key={it.id}
                to={`/accident-types/${it.slug}`}
                className="card-elevated p-6 md:p-7 group"
                data-testid={`accident-type-card-${it.slug}`}
              >
                <div className="w-12 h-12 rounded-xl bg-forest/5 text-forest grid place-items-center mb-5 group-hover:bg-terracotta group-hover:text-white transition">
                  <I className="w-6 h-6" />
                </div>
                <h3 className="font-display font-bold text-xl md:text-2xl text-forest mb-2 leading-tight">{it.name}</h3>
                <p className="text-sm md:text-base text-charcoal-soft leading-relaxed mb-4">{it.short_description}</p>
                <div className="flex items-center gap-2 text-terracotta font-bold text-sm group-hover:gap-3 transition-all">
                  Read full guide <ArrowRight className="w-4 h-4" />
                </div>
              </Link>
            );
          })}
        </div>
      </section>
      <CTASection />
    </>
  );
}
